import { render } from "./BackupManagement.vue?vue&type=template&id=1c8f44d3&scoped=true"
import script from "./BackupManagement.vue?vue&type=script&lang=js"
export * from "./BackupManagement.vue?vue&type=script&lang=js"

import "./BackupManagement.vue?vue&type=style&index=0&id=1c8f44d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8f44d3"]])

export default __exports__